iScreenWizard.factory('Opleidingsniveau', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('opleidingsniveau', params).then(function (response) {
                var opleidingsniveaus = response.data;
                resolve(opleidingsniveaus);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('opleidingsniveau/'+id).then(function (response) {
                var opleidingsniveau = response.data;
                resolve(opleidingsniveau);
            }, reject);
        });
    };

    return data;
});